<!-- notification-item.component.html -->
<div class="notification-item" [class]="notification.type">

  <div class="notification-icon" [innerHTML]="getSafeIcon()"></div>

    <div class="notification-content">
      <div class="notification-title" *ngIf="notification.title">
        {{ notification.title }}
      </div>
      <div class="notification-message">{{ notification.message }}</div>
      <button
        *ngIf="notification.action"
        class="notification-action"
        (click)="handleAction()"
      >
        {{ notification.action.label }}
      </button>
    </div>

  </div>